import { useEffect } from "react";
import { notification } from "antd";
import { UserInfo } from "@entities/project";
import { useCoordinator } from "@shared/lib/hooks";
import { UsersInfiniteScroll } from "../../../user-infinite-scroll";

interface IRepresentationFormEmail {
  projectParticipantId?: string;
  onUserSelect: (user: UserInfo) => void;
  error?: string;
  clearTrigger?: number;
}

export const RepresentationFormEmail = ({
  projectParticipantId,
  onUserSelect,
  error,
  clearTrigger = 0,
}: IRepresentationFormEmail) => {
  const { projectId } = useCoordinator();

  useEffect(() => {
    if (error) {
      notification.error({
        message: "Неудачный запрос",
        description: error,
        placement: "topRight",
      });
    }
  }, [error]);

  return (
    <div className="email-input-container">
      <div className="email-input-label">
        <div className="email-input-title">Электронная почта</div>
        <UsersInfiniteScroll
          projectId={projectId}
          projectParticipantId={projectParticipantId}
          onUserSelect={onUserSelect}
          clearTrigger={clearTrigger}
        />
      </div>
    </div>
  );
};
